import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Calendar, MessageSquare, ArrowRight } from "lucide-react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import Reveal from "../components/Reveal";

export const posts = [
  { slug: "how-moggies-and-doggies-is-redefining-modern-veterinary-experience", cat: "Pet Nutrition", title: "How Moggies & Doggies Is Redefining Modern Veterinary Experience", img: "img_17.jpg" },
  { slug: "the-moggies-and-doggies-philosophy-compassion-at-the-heart-of-every-visit", cat: "Clinic Insights", title: "The Moggies & Doggies Philosophy: Compassion at the Heart of Every Visit", img: "img_9.jpg" },
  { slug: "understanding-separation-anxiety-in-pets-and-how-to-ease-it", cat: "Pet Behavior", title: "Understanding Separation Anxiety in Pets and How to Ease It", img: "img_8.jpg" },
  { slug: "choosing-the-right-diet-for-your-pets-life-stage", cat: "Pet Nutrition", title: "Choosing the Right Diet for Your Pet's Life Stage", img: "img_5.jpg" },
  { slug: "daily-grooming-habits-that-keep-your-pet-happy-and-healthy", cat: "Pet Care", title: "Daily Grooming Habits That Keep Your Pet Happy and Healthy", img: "img_3.jpg" },
  { slug: "how-to-spot-early-signs-of-illness-in-your-pet", cat: "Pet Health", title: "How to Spot Early Signs of Illness in Your Pet", img: "img_2b.jpg" },
];

const EXCERPT =
  "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur";

const Blog = () => {
  useEffect(() => { document.title = "Article & News – Moggies & Doggies Veterinary Care"; }, []);
  return (
    <div className="min-h-screen bg-white font-body text-pawelle-body">
      <SiteHeader />
      <main>
        <PageBanner title="Article & News" subtitle="Insights, Tips & Stories from Our Veterinary Experts" crumbs={["Blog"]} />

        <section className="mx-auto max-w-[1290px] px-5 py-20 md:py-28">
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {posts.map((p, i) => (
              <Reveal key={p.slug} animation="fadeInUp" delay={i * 80} className="group flex flex-col overflow-hidden rounded-[28px] bg-white shadow-[0_14px_40px_rgba(67,48,109,0.06)] transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_24px_60px_rgba(114,82,155,0.15)]">
                <Link to={`/gb/en/blog/${p.slug}.html`} className="block overflow-hidden">
                  <img src={`/pawelle/${p.img}`} alt={p.title} className="aspect-[16/10] w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </Link>
                <div className="flex flex-1 flex-col p-7">
                  <span className="inline-flex w-fit rounded-full bg-pawelle-bg px-3 py-1 font-body text-[13px] font-bold text-pawelle-primary">{p.cat}</span>
                  <Link to={`/gb/en/blog/${p.slug}.html`} className="mt-4">
                    <h3 className="font-display text-[21px] font-semibold leading-snug text-pawelle-ink transition-colors group-hover:text-pawelle-primary">{p.title}</h3>
                  </Link>
                  <p className="mt-3 font-body text-[15px] leading-relaxed text-pawelle-body">{EXCERPT}</p>
                  <div className="mt-5 flex items-center gap-5 border-t border-pawelle-ink/10 pt-4 font-body text-[13px] text-pawelle-body">
                    <span className="flex items-center gap-1.5"><Calendar className="h-4 w-4 text-pawelle-primary" /> November 10, 2025</span>
                    <span className="flex items-center gap-1.5"><MessageSquare className="h-4 w-4 text-pawelle-primary" /> No Comments</span>
                  </div>
                  <Link to={`/gb/en/blog/${p.slug}.html`} className="mt-5 inline-flex items-center gap-1 font-display text-[15px] font-medium text-pawelle-primary transition-all hover:gap-2">
                    Read More <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </Reveal>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Blog;
